import PropTypes from "prop-types";
import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import ReportDefinitions from "../../../../../common/config/ReportDefinitions";
import CarditCriticalElementsReport from "../../components/CarditCriticalElementsReport";
import {
  COLUMN_ACCESSOR_RECEPTACLES_TOTAL,
  PROPERTY_ORIGINAL_GRAND_TOTAL,
  getFilteredAndSortedData,
  getColumns,
  getOriginalGrandTotal,
  getIsFiltered,
  getGeneratedOnDateTime,
  getIsLoading,
} from "../redux/selectors/CarditCriticalElementsLocationSelectors";
import CarditCriticalElementsLocationReportMode from "./CarditCriticalElementsLocationReportMode";
import {
  getLeafColumns,
  setPropertyValueByPath,
  getPropertyValueByPath,
  deepClone,
} from "../../../../../react-table/helpers/utils";
import {
  changeReportMode,
  changeReportSorting,
  changeReportFiltering,
} from "../../../../common/redux/actions/ReportsActions";
import {
  getReportFiltering,
  getReportMode,
} from "../../../../common/redux/selectors/ReportsSelectors";

const MODE_TABS = [
  { value: CarditCriticalElementsLocationReportMode.percentage, label: "%" },
  { value: CarditCriticalElementsLocationReportMode.number, label: "#" },
];

class CarditCriticalElementsLocationContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillUnmount() {
    this.props.changeReportFiltering({
      reportDefinition: {
        id: ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_LOCATION.id,
      },
      sorting: {},
      filtering: {},
    });
  }

  onLocationReportSortedChange = (newSorted, column, shiftKey) => {
    this.props.changeReportSorting({
      reportDefinition: {
        id: ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_LOCATION.id,
      },
      sorting: {
        newSorted,
        column,
        shiftKey,
      },
    });
  };

  onLocationReportFilteredChange = (column, value) => {
    this.props.changeReportFiltering({
      reportDefinition: {
        id: ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_LOCATION.id,
      },
      filtering: {
        appliedFilters: column,
        appliedColumn: value,
      },
    });
  };

  // eslint-disable-next-line react/sort-comp
  changeMode = (reportMode) => {
    this.props.changeReportMode({
      reportDefinition: {
        id: ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_LOCATION.id,
      },
      reportMode,
    });
  };

  getColumnsWithOriginalGrandTotal() {
    // eslint-disable-next-line prefer-destructuring
    const columns = this.props.columns;

    const transformedColumns = deepClone(columns);

    const leafColumns = getLeafColumns(transformedColumns);
    const columnWithGrandTotalLink = leafColumns.find(
      (column) => column.accessor === COLUMN_ACCESSOR_RECEPTACLES_TOTAL
    );

    const originalGrandTotal = getPropertyValueByPath(
      columnWithGrandTotalLink,
      PROPERTY_ORIGINAL_GRAND_TOTAL
    );
    if (
      !originalGrandTotal &&
      this.props.isFiltered &&
      this.props.originalGrandTotal
    ) {
      setPropertyValueByPath(
        columnWithGrandTotalLink,
        PROPERTY_ORIGINAL_GRAND_TOTAL,
        this.props.originalGrandTotal
      );
    }

    return transformedColumns;
  }

  render() {
    return (
      <CarditCriticalElementsReport
        reportId={ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_LOCATION.id}
        prepareData={(d) =>
          d.filter(
            (row) => row.carrier && row.carrier.toLowerCase() !== "total"
          )
        }
        columns={this.getColumnsWithOriginalGrandTotal.apply(this)}
        isLoading={this.props.isLoading}
        generatedOnDateTime={this.props.generatedDateTime}
        data={this.props.data}
        modeTabs={MODE_TABS}
        changeMode={this.changeMode}
        mode={this.props.mode}
        onSortedChange={this.onLocationReportSortedChange}
        onFilteredChange={this.onLocationReportFilteredChange}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  data: getFilteredAndSortedData(state),
  generatedDateTime: getGeneratedOnDateTime(state),
  isLoading: getIsLoading(state),
  columns: getColumns(state),
  mode: getReportMode(
    state,
    ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_LOCATION.id
  ),
  isFiltered: getIsFiltered(state),
  originalGrandTotal: getOriginalGrandTotal.apply(this, [state]),
  filteringState: getReportFiltering(
    state,
    ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_LOCATION.id
  ),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      changeReportMode,
      changeReportSorting,
      changeReportFiltering,
    },
    dispatch
  );

CarditCriticalElementsLocationContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  columns: PropTypes.arrayOf(PropTypes.object),
  changeReportMode: PropTypes.func,
  changeReportSorting: PropTypes.func,
  changeReportFiltering: PropTypes.func,
  mode: PropTypes.string,
  isFiltered: PropTypes.bool,
  originalGrandTotal: PropTypes.number,
  // eslint-disable-next-line react/forbid-prop-types,react/no-unused-prop-types
  filteringState: PropTypes.object,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CarditCriticalElementsLocationContainer);
